module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('upgrade-plan-card', {
    attrs: {
      "title": _vm.titlePlusPlan,
      "subtitle": _vm.subtitlePlusPlan,
      "description": _vm.descriptionPlusPlan,
      "price": 999,
      "planData": _vm.homePlusPlanDetail,
      "planCostDifference": _vm.planCostDifference,
      "planDeductibleRange": _vm.deductibleRangePlusPlan
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex-ns flex-wrap justify-end"
  }, [_c('div', {
    staticClass: "order-1 mb3 mb0-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.debounceMethod(function () { return _vm.updateCoverage(_vm.coverage_upgrade.id); })
      }
    }
  }, [_vm._v("Upgrade Now\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mr3-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b2c2aa60", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2c2aa60","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upgrade-plan/UpgradeHomePlusPlan.vue
// module id = 1466
// module chunks = 0